import { Routes } from '@angular/router';
import { commonRoutes } from './app.common-routes';
import { authGuard } from './guards/auth.guard';
import { dateOfBirthGateGuard } from './guards/date-of-birth-gate.guard';
import { interestPageGuard } from './guards/interest-page.guard';
import { tripAgreementsGuard } from './guards/trip-agreements.guard';
import { groupManagementRoute } from './guards/trip-switch-routes';
import { withLegacyUrlCanonicalizer } from './routing/with-legacy-url-canonicalizer';

export const routes: Routes = withLegacyUrlCanonicalizer([
  {
    ...groupManagementRoute,
    loadComponent: () => import('./pages/group-management/group-management.page').then(m => m.GroupManagementPage),
  },
  {
    path: 'interest-page',
    canActivate: [authGuard, dateOfBirthGateGuard, tripAgreementsGuard, interestPageGuard],
    loadComponent: () => import('./pages/interest-page/interest-page.page').then(m => m.InterestPagePage),
  },
  ...commonRoutes,
]);
